var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003865",
    fillRule: "evenodd",
    d: "M15 3v1H4l-.001 11.998L14.84 16a1.16 1.16 0 0 0 1.153-1.033L16 14.84V7h1v7.84a2.16 2.16 0 0 1-2.006 2.155L14.84 17 3 16.998V3h12Zm2.249.644.702.712-8.476 8.369L6.027 8.87l.746-.667 2.746 3.071 7.73-7.63Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export default ForwardRef;